import React, { useState, useEffect } from "react";
import {
  Button,
  Box,
  Typography,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Radio,
  RadioGroup,
  FormControlLabel,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  InputAdornment,
  Grid,
  useMediaQuery,
  useTheme,
  Chip,
  Tooltip,
  Fade,
  Drawer,
  AppBar,
  Toolbar,
  Menu,
  MenuItem,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Avatar,
  Badge,
  Tabs,
  Tab,
  Select,
  FormControl,
  InputLabel,
  Switch,
  Slider,
  CircularProgress,
  Alert,
  Snackbar,
  Breadcrumbs,
  Link,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import {
  Edit as EditIcon,
  Close as CloseIcon,
  Add as AddIcon,
  Star as StarIcon,
  StarBorder as StarBorderIcon,
  ContentCopy as CopyIcon,
  DeleteOutline as DeleteIcon,
  Search as SearchIcon,
  Info as InfoIcon,
  CheckCircle as CheckCircleIcon,
  Menu as MenuIcon,
  FilterList as FilterIcon,
  Sort as SortIcon,
  Download as DownloadIcon,
  Print as PrintIcon,
  Share as ShareIcon,
  MoreVert as MoreVertIcon,
  ArrowBack as ArrowBackIcon,
  ExpandMore as ExpandMoreIcon,
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon,
  Calculate as CalculateIcon,
  AttachMoney as MoneyIcon,
  AccountBalance as BankIcon,
  Receipt as ReceiptIcon,
  Person as PersonIcon,
  Group as GroupIcon,
  Business as BusinessIcon,
  Settings as SettingsIcon,
  HelpOutline as HelpIcon,
  Notifications as NotificationsIcon,
  Dashboard as DashboardIcon,
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
  FirstPage as FirstPageIcon,
  LastPage as LastPageIcon,
  KeyboardArrowLeft as KeyboardArrowLeftIcon,
  KeyboardArrowRight as KeyboardArrowRightIcon,
  Refresh as RefreshIcon,
  Save as SaveIcon,
  Cancel as CancelIcon,
  Check as CheckIcon,
  Warning as WarningIcon,
  Error as ErrorIcon,
} from "@mui/icons-material";

function Saturated() {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('xs'));
  const isSm = useMediaQuery(theme.breakpoints.down('sm'));
  const isMd = useMediaQuery(theme.breakpoints.down('md'));
  const isLg = useMediaQuery(theme.breakpoints.down('lg'));
  
  const isMobile = isSm;
  const isTablet = isMd && !isSm;
  const isDesktop = !isMd;

  const [structureDetails, setStructureDetails] = useState({
    0: {
      id: "0",
      title: "Generic Salary Structure 2",
      name: "Generic Salary Structure 2",
      description: "This is the default salary structure for regular employees.",
      isDefault: true,
      employeeCount: 0,
      lastUpdated: "2024-01-15",
      earnings: [
        { id: 1, name: "Basic", calculation: "CTC * 0.2", type: "earning", editable: true },
        { id: 2, name: "HRA", calculation: "BASIC * 0.4", type: "earning", editable: true },
        { id: 3, name: "Conveyance Allowance", calculation: "Fixed", amount: 1600, type: "earning", editable: true },
        { id: 4, name: "Leave Travel Allowance", calculation: "Fixed", amount: 0, type: "earning", editable: true },
        { id: 5, name: "Phone Reimbursement", calculation: "Fixed", amount: 0, type: "earning", editable: true },
      ],
      deductions: [
        { id: 6, name: "PF Employer", calculation: "System Calculated", type: "deduction", editable: false },
        { id: 7, name: "ESI Employer", calculation: "System Calculated", type: "deduction", editable: false },
      ],
    },
    1: {
      id: "1",
      title: "Sample Salary Structure 2 without gratuity",
      name: "Generic Salary Structure 2",
      description: "Salary structure without gratuity component.",
      isDefault: false,
      employeeCount: 5,
      lastUpdated: "2024-01-10",
      earnings: [
        { id: 1, name: "Basic", calculation: "CTC * 0.2", type: "earning", editable: true },
        { id: 2, name: "HRA", calculation: "BASIC * 0.4", type: "earning", editable: true },
        { id: 3, name: "Conveyance Allowance", calculation: "Fixed", amount: 1600, type: "earning", editable: true },
      ],
      deductions: [
        { id: 6, name: "PF Employer", calculation: "System Calculated", type: "deduction", editable: false },
        { id: 7, name: "ESI Employer", calculation: "System Calculated", type: "deduction", editable: false },
      ],
    },
  });

  const structures = [
    { id: "0", name: "Generic Salary Structure 2", type: "Regular", employeeCount: 0, isDefault: true },
    { id: "1", name: "Sample Salary Structure 2 without gratuity", type: "Regular", employeeCount: 5, isDefault: false },
    { id: "2", name: "Contractor Salary Structure", type: "Contractor", employeeCount: 12, isDefault: false },
    { id: "3", name: "PLP BASIC 20%", type: "Regular", employeeCount: 3, isDefault: false },
    { id: "4", name: "Salary Structure 2", type: "Regular", employeeCount: 8, isDefault: false },
    { id: "5", name: "Salary Structure_4", type: "Regular", employeeCount: 2, isDefault: false },
    { id: "6", name: "Contractor Salary Structure_1", type: "Contractor", employeeCount: 7, isDefault: false },
  ];

  const [selected, setSelected] = useState("0");
  const [subSection, setSubSection] = useState("CREATE STRUCTURE");
  const [showCreatePopup, setShowCreatePopup] = useState(false);
  const [showComponentPopup, setShowComponentPopup] = useState(false);
  const [selectedType, setSelectedType] = useState("Regular");
  const [searchQuery, setSearchQuery] = useState("");
  const [newComponent, setNewComponent] = useState({ name: "", type: "earning", calculation: "" });
  const [mobileView, setMobileView] = useState(false);
  const [showStructureList, setShowStructureList] = useState(true);
  const [showStructureDetails, setShowStructureDetails] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  const sections = [
    "CREATE STRUCTURE",
    "PROVIDENT FUND",
    "PROFESSIONAL TAX",
    "INCOME TAXES",
  ];

  useEffect(() => {
    if (isMobile) {
      setMobileView(true);
    } else {
      setMobileView(false);
    }
  }, [isMobile]);

  const filteredStructures = structures.filter(structure =>
    structure.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleEditName = () => {
    const newName = prompt(
      "Enter new structure name:",
      structureDetails[selected]?.name
    );
    if (newName && newName.trim()) {
      setStructureDetails(prev => ({
        ...prev,
        [selected]: {
          ...prev[selected],
          name: newName,
          title: newName,
        }
      }));
      showSnackbar("Structure name updated successfully!", "success");
    }
  };

  const handleSetDefault = (id) => {
    const updatedStructures = { ...structureDetails };
    Object.keys(updatedStructures).forEach(key => {
      updatedStructures[key].isDefault = key === id;
    });
    setStructureDetails(updatedStructures);
    showSnackbar("Default structure updated!", "success");
  };

  const handleAddComponent = () => {
    if (newComponent.name.trim() && newComponent.calculation.trim()) {
      const component = {
        id: Date.now(),
        name: newComponent.name,
        calculation: newComponent.calculation,
        type: newComponent.type,
        amount: newComponent.calculation === "Fixed" ? 0 : undefined,
        editable: true
      };

      setStructureDetails(prev => ({
        ...prev,
        [selected]: {
          ...prev[selected],
          [newComponent.type === "earning" ? "earnings" : "deductions"]: [
            ...prev[selected][newComponent.type === "earning" ? "earnings" : "deductions"],
            component
          ]
        }
      }));

      setNewComponent({ name: "", type: "earning", calculation: "" });
      setShowComponentPopup(false);
      showSnackbar("Component added successfully!", "success");
    }
  };

  const handleDeleteComponent = (type, id) => {
    if (window.confirm("Are you sure you want to delete this component?")) {
      setStructureDetails(prev => ({
        ...prev,
        [selected]: {
          ...prev[selected],
          [type]: prev[selected][type].filter(comp => comp.id !== id)
        }
      }));
      showSnackbar("Component deleted!", "info");
    }
  };

  const showSnackbar = (message, severity) => {
    setSnackbar({ open: true, message, severity });
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const renderMobileView = () => (
    <Box sx={{ width: "100%", overflow: "hidden" }}>
      {/* Mobile Header with Back Button */}
      <AppBar 
        position="sticky" 
        sx={{ 
          backgroundColor: "white", 
          color: "primary.main",
          boxShadow: 1 
        }}
      >
        <Toolbar sx={{ px: 1 }}>
          {!showStructureDetails && (
            <IconButton
              edge="start"
              color="inherit"
              onClick={() => {
                setShowStructureDetails(true);
                setShowStructureList(false);
              }}
              sx={{ mr: 1 }}
            >
              <ArrowBackIcon />
            </IconButton>
          )}
          
          <Typography variant="h6" sx={{ flexGrow: 1, fontSize: "1rem" }}>
            {showStructureDetails ? "Salary Structures" : structureDetails[selected]?.title}
          </Typography>
          
          <IconButton color="inherit" onClick={() => setShowCreatePopup(true)}>
            <AddIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* Mobile Navigation Tabs */}
      <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: 'white' }}>
        <Tabs
          value={activeTab}
          onChange={(e, newValue) => setActiveTab(newValue)}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{
            minHeight: 48,
            '& .MuiTab-root': {
              minHeight: 48,
              fontSize: '0.75rem',
              textTransform: 'none',
              minWidth: 'auto',
              px: 1.5,
            }
          }}
        >
          {sections.map((section, index) => (
            <Tab 
              key={section} 
              label={section.split(' ')[0]} 
              icon={index === 0 ? <ReceiptIcon /> : index === 1 ? <BankIcon /> : index === 2 ? <MoneyIcon /> : <CalculateIcon />}
              iconPosition="start"
              sx={{ fontSize: '0.7rem !important' }}
            />
          ))}
        </Tabs>
      </Box>

      {/* Mobile Content */}
      <Box sx={{ p: 1.5 }}>
        {showStructureList && (
          <Box>
            {/* Search Bar */}
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Search structures..."
              size="small"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon fontSize="small" />
                  </InputAdornment>
                ),
              }}
              sx={{
                mb: 2,
                '& .MuiOutlinedInput-root': {
                  borderRadius: 2,
                }
              }}
            />

            {/* Create Button */}
            <Button
              fullWidth
              variant="contained"
              startIcon={<AddIcon />}
              onClick={() => setShowCreatePopup(true)}
              sx={{
                mb: 2,
                borderRadius: 2,
                py: 1.2,
                background: "linear-gradient(135deg, #7564e6, #7564e6)",
                color: "white",
                fontWeight: 600,
                textTransform: "none",
                fontSize: "0.9rem",
              }}
            >
              Create New Structure
            </Button>

            {/* Structure List */}
            <List sx={{ width: "100%" }}>
              {filteredStructures.map((structure) => (
                <Card
                  key={structure.id}
                  elevation={1}
                  sx={{
                    mb: 1.5,
                    borderRadius: 2,
                    border: "1px solid",
                    borderColor: selected === structure.id ? "primary.main" : "divider",
                    backgroundColor: selected === structure.id ? "primary.light" : "white",
                  }}
                  onClick={() => {
                    setSelected(structure.id);
                    setShowStructureList(false);
                    setShowStructureDetails(true);
                  }}
                >
                  <CardContent sx={{ py: 1.5, px: 2 }}>
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 0.5 }}>
                          <Typography 
                            variant="subtitle2" 
                            fontWeight={600}
                            sx={{ 
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap"
                            }}
                          >
                            {structure.name}
                          </Typography>
                          {structure.isDefault && (
                            <StarIcon sx={{ fontSize: 14, color: "warning.main", flexShrink: 0 }} />
                          )}
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
                          <Chip
                            label={structure.type}
                            size="small"
                            sx={{
                              height: 18,
                              fontSize: "0.6rem",
                              backgroundColor: structure.type === "Contractor" ? "#FFE8E8" : "#E8F4FF",
                              color: structure.type === "Contractor" ? "#FF6B6B" : "#7564e6",
                            }}
                          />
                          <Typography variant="caption" color="text.secondary">
                            {structure.employeeCount} employees
                          </Typography>
                        </Box>
                      </Box>
                      <IconButton
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleSetDefault(structure.id);
                        }}
                        sx={{ flexShrink: 0 }}
                      >
                        {structure.isDefault ? (
                          <StarIcon sx={{ fontSize: 16, color: "warning.main" }} />
                        ) : (
                          <StarBorderIcon sx={{ fontSize: 16 }} />
                        )}
                      </IconButton>
                    </Box>
                  </CardContent>
                </Card>
              ))}
            </List>
          </Box>
        )}

        {showStructureDetails && (
          <Box>
            {/* Mobile Structure Details */}
            <Card sx={{ borderRadius: 2, mb: 2 }}>
              <CardContent>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 2 }}>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="h6" fontWeight={600} color="primary" sx={{ fontSize: "1.1rem" }}>
                      {structureDetails[selected]?.title}
                    </Typography>
                    {structureDetails[selected]?.isDefault && (
                      <Chip
                        icon={<CheckCircleIcon sx={{ fontSize: 12 }} />}
                        label="Default"
                        size="small"
                        sx={{
                          mt: 0.5,
                          height: 20,
                          fontSize: "0.65rem",
                          backgroundColor: "success.light",
                          color: "success.dark",
                        }}
                      />
                    )}
                  </Box>
                  <IconButton
                    size="small"
                    onClick={() => {
                      setShowStructureDetails(false);
                      setShowStructureList(true);
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </Box>

                {/* Structure Info */}
                <Box sx={{ mb: 3 }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
                    <Typography variant="body2" fontWeight={600} color="text.primary">
                      Name:
                    </Typography>
                    <Typography variant="body2" sx={{ flex: 1 }}>
                      {structureDetails[selected]?.name}
                    </Typography>
                    <IconButton size="small" onClick={handleEditName}>
                      <EditIcon fontSize="small" />
                    </IconButton>
                  </Box>
                  <Box sx={{ mb: 1.5 }}>
                    <Typography variant="body2" fontWeight={600} color="text.primary" gutterBottom>
                      Description:
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {structureDetails[selected]?.description}
                    </Typography>
                  </Box>
                  
                  <Box sx={{ display: "flex", gap: 1.5, mb: 2 }}>
                    <Box sx={{ flex: 1, textAlign: "center", p: 1, bgcolor: "action.hover", borderRadius: 1 }}>
                      <Typography variant="h6" color="primary" fontWeight={700}>
                        {structureDetails[selected]?.employeeCount}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        Employees
                      </Typography>
                    </Box>
                    <Box sx={{ flex: 1, textAlign: "center", p: 1, bgcolor: "action.hover", borderRadius: 1 }}>
                      <Typography variant="h6" color="primary" fontWeight={700}>
                        {structureDetails[selected]?.earnings.length + structureDetails[selected]?.deductions.length}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        Components
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                {/* Components - Mobile Accordion View */}
                <Typography variant="subtitle1" fontWeight={600} color="primary" gutterBottom>
                  Salary Components
                </Typography>

                <Accordion defaultExpanded sx={{ mb: 1.5 }}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="body2" fontWeight={600}>
                      Earnings ({structureDetails[selected]?.earnings.length})
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ p: 0 }}>
                    <List dense>
                      {structureDetails[selected]?.earnings.map((earning) => (
                        <ListItem
                          key={earning.id}
                          secondaryAction={
                            earning.editable && (
                              <IconButton edge="end" size="small" onClick={() => handleDeleteComponent("earnings", earning.id)}>
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            )
                          }
                          sx={{
                            borderBottom: "1px solid",
                            borderColor: "divider",
                            py: 1,
                          }}
                        >
                          <ListItemText
                            primary={
                              <Typography variant="body2" fontWeight={500}>
                                {earning.name}
                              </Typography>
                            }
                            secondary={
                              <Chip
                                label={earning.calculation}
                                size="small"
                                sx={{
                                  mt: 0.5,
                                  height: 20,
                                  fontSize: "0.65rem",
                                  backgroundColor: earning.calculation === "Fixed" ? "#E8F5E9" : "#E3F2FD",
                                  color: earning.calculation === "Fixed" ? "#2E7D32" : "#7564e6",
                                }}
                              />
                            }
                          />
                        </ListItem>
                      ))}
                    </List>
                  </AccordionDetails>
                </Accordion>

                <Accordion defaultExpanded>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="body2" fontWeight={600}>
                      Deductions ({structureDetails[selected]?.deductions.length})
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ p: 0 }}>
                    <List dense>
                      {structureDetails[selected]?.deductions.map((deduction) => (
                        <ListItem
                          key={deduction.id}
                          secondaryAction={
                            deduction.editable && (
                              <IconButton edge="end" size="small" onClick={() => handleDeleteComponent("deductions", deduction.id)}>
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            )
                          }
                          sx={{
                            borderBottom: "1px solid",
                            borderColor: "divider",
                            py: 1,
                          }}
                        >
                          <ListItemText
                            primary={
                              <Typography variant="body2" fontWeight={500}>
                                {deduction.name}
                              </Typography>
                            }
                            secondary={
                              <Chip
                                label={deduction.calculation}
                                size="small"
                                sx={{
                                  mt: 0.5,
                                  height: 20,
                                  fontSize: "0.65rem",
                                  backgroundColor: "#FFEBEE",
                                  color: "#C62828",
                                }}
                              />
                            }
                          />
                        </ListItem>
                      ))}
                    </List>
                  </AccordionDetails>
                </Accordion>

                {/* Set Default Button */}
                <Button
                  fullWidth
                  variant="contained"
                  startIcon={structureDetails[selected]?.isDefault ? <CheckCircleIcon /> : <StarBorderIcon />}
                  onClick={() => handleSetDefault(selected)}
                  sx={{
                    mt: 2,
                    borderRadius: 2,
                    py: 1,
                    background: structureDetails[selected]?.isDefault 
                      ? "linear-gradient(45deg, #4CAF50 30%, #2E7D32 90%)"
                      : "linear-gradient(45deg, #7564e6 30%, #7564e6 90%)",
                    color: "white",
                    fontWeight: 600,
                    textTransform: "none",
                  }}
                >
                  {structureDetails[selected]?.isDefault ? "Default Structure" : "Set as Default"}
                </Button>

                {/* Add Component Button */}
                <Button
                  fullWidth
                  variant="outlined"
                  startIcon={<AddIcon />}
                  onClick={() => setShowComponentPopup(true)}
                  sx={{
                    mt: 1.5,
                    borderRadius: 2,
                    py: 1,
                    borderColor: "primary.main",
                    color: "primary.main",
                    fontWeight: 600,
                    textTransform: "none",
                  }}
                >
                  Add New Component
                </Button>
              </CardContent>
            </Card>
          </Box>
        )}
      </Box>
    </Box>
  );

  const renderDesktopView = () => (
    <Box sx={{ width: "100%" }}>
      {/* Section Navigation - Desktop */}
      <Box sx={{ mb: 3 }}>
        <Grid 
          container 
          spacing={1}
          sx={{
            flexWrap: isMd ? 'wrap' : 'nowrap',
            justifyContent: isSm ? 'center' : 'flex-start'
          }}
        >
          {sections.map((section) => (
            <Grid item key={section}>
              <Button
                variant="contained"
                onClick={() => setSubSection(section)}
                sx={{
                  borderRadius: 6,
                  px: { xs: 2, sm: 3 },
                  py: 1.2,
                  fontSize: { xs: "0.7rem", sm: "0.8rem", md: "0.875rem" },
                  fontWeight: "bold",
                  textTransform: "none",
                //  background: "linear-gradient(135deg, #7564e6, #7564e6)",
                  background: subSection === section 
                    ? "linear-gradient(45deg, #7564e6 30%, #7564e6 90%)"
                    : "linear-gradient(45deg, #7564e6 30%, #7564e6 90%)",
                  color: "white",
                  whiteSpace: "nowrap",
                  minWidth: { xs: "130px", sm: "150px", md: "180px" },
                  "&:hover": {
                     background: "linear-gradient(135deg, #7564e6, #7564e6)",
                  }
                }}
              >
                {isSm ? section.split(' ')[0] : section}
              </Button>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Main Content - Desktop */}
      {subSection === "CREATE STRUCTURE" && (
        <Grid 
          container 
          spacing={isSm ? 1 : 3}
          sx={{ 
            flexDirection: isSm ? 'column' : 'row',
            alignItems: 'stretch'
          }}
        >
          {/* Structure List */}
          <Grid 
            item 
            xs={12} 
            sm={12} 
            md={isMd ? 12 : 4} 
            lg={3}
            sx={{ 
              width: '100%',
              display: { xs: showStructureList ? 'block' : 'none', md: 'block' }
            }}
          >
            {renderStructureList()}
          </Grid>

          {/* Structure Details */}
          <Grid 
            item 
            xs={12} 
            sm={12} 
            md={isMd ? 12 : 8} 
            lg={9}
            sx={{ 
              width: '100%',
              display: { xs: showStructureDetails ? 'block' : 'none', md: 'block' }
            }}
          >
            {renderStructureDetails()}
          </Grid>
        </Grid>
      )}
    </Box>
  );

  const renderStructureList = () => (
    <Card 
      sx={{ 
        borderRadius: 3, 
        boxShadow: 3,
        height: "100%",
        minHeight: isSm ? 'auto' : 'calc(100vh - 200px)',
        backgroundColor: "background.paper"
      }}
    >
      <CardContent>
        <Box sx={{ mb: 3 }}>
          <Typography variant="h6" fontWeight={600} color="primary" gutterBottom>
            Salary Structures
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Search structures..."
            size="small"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" color="action" />
                </InputAdornment>
              ),
            }}
            sx={{
              borderRadius: 2,
              "& .MuiOutlinedInput-root": {
                borderRadius: 2,
              }
            }}
          />
        </Box>

        <Box sx={{ mb: 2 }}>
          <Button
            fullWidth
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => setShowCreatePopup(true)}
            sx={{
              borderRadius: 2,
              py: 1.5,
               background: "linear-gradient(135deg, #7564e6, #7564e6)",
              color: "white",
              fontWeight: 600,
              textTransform: "none",
              fontSize: "0.95rem",
              "&:hover": {
                 background: "linear-gradient(135deg, #7564e6, #7564e6)",
              }
            }}
          >
            Create New Structure
          </Button>
        </Box>

        <Box sx={{ 
          maxHeight: isSm ? '400px' : 'calc(100vh - 350px)', 
          overflowY: "auto", 
          pr: 1 
        }}>
          {filteredStructures.map((structure) => (
            <Fade in key={structure.id}>
              <Card
                elevation={0}
                sx={{
                  mb: 1.5,
                  borderRadius: 2,
                  border: "1px solid",
                  borderColor: selected === structure.id ? "primary.main" : "divider",
                  backgroundColor: selected === structure.id ? "primary.light" : "background.paper",
                  cursor: "pointer",
                  transition: "all 0.2s",
                  "&:hover": {
                    borderColor: "primary.main",
                    transform: "translateY(-2px)",
                    boxShadow: 2,
                  }
                }}
                onClick={() => setSelected(structure.id)}
              >
                <CardContent sx={{ py: 1.5, px: 2 }}>
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                    <Box>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
                        <Typography 
                          variant="subtitle2" 
                          fontWeight={600}
                          sx={{ 
                            fontSize: isSm ? '0.8rem' : '0.875rem',
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            maxWidth: isSm ? '150px' : '200px'
                          }}
                        >
                          {structure.name}
                        </Typography>
                        {structure.isDefault && (
                          <Tooltip title="Default Structure">
                            <StarIcon sx={{ fontSize: 16, color: "warning.main" }} />
                          </Tooltip>
                        )}
                      </Box>
                      <Chip
                        label={structure.type}
                        size="small"
                        sx={{
                          height: 20,
                          fontSize: "0.65rem",
                          backgroundColor: structure.type === "Contractor" ? "#FFE8E8" : "#E8F4FF",
                          color: structure.type === "Contractor" ? "#FF6B6B" : "#7564e6",
                        }}
                      />
                    </Box>
                    <IconButton
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleSetDefault(structure.id);
                      }}
                      sx={{ color: "action.active" }}
                    >
                      {structure.isDefault ? (
                        <StarIcon sx={{ color: "warning.main" }} />
                      ) : (
                        <StarBorderIcon />
                      )}
                    </IconButton>
                  </Box>
                  <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
                    <Typography variant="caption" color="text.secondary">
                      {structure.employeeCount} employees
                    </Typography>
                    <CloseIcon sx={{ fontSize: 14, color: "text.disabled" }} />
                  </Box>
                </CardContent>
              </Card>
            </Fade>
          ))}
        </Box>
      </CardContent>
    </Card>
  );

  const renderStructureDetails = () => {
    const currentStructure = structureDetails[selected];
    if (!currentStructure) return null;

    return (
      <Card sx={{ 
        borderRadius: 3, 
        boxShadow: 3, 
        height: "100%",
        minHeight: isSm ? 'auto' : 'calc(100vh - 200px)'
      }}>
        <CardContent>
          {/* Header */}
          <Box sx={{ 
            display: "flex", 
            justifyContent: "space-between", 
            alignItems: "flex-start", 
            mb: 3,
            flexDirection: isSm ? 'column' : 'row',
            gap: isSm ? 2 : 0
          }}>
            <Box sx={{ width: isSm ? '100%' : 'auto' }}>
              <Typography 
                variant="h5" 
                fontWeight={700} 
                color="primary" 
                gutterBottom
                sx={{ fontSize: isSm ? '1.25rem' : '1.5rem' }}
              >
                {currentStructure.title}
              </Typography>
              {currentStructure.isDefault && (
                <Chip
                  icon={<CheckCircleIcon sx={{ fontSize: 16 }} />}
                  label="Default Structure"
                  size="small"
                  sx={{
                    backgroundColor: "success.light",
                    color: "success.dark",
                    fontWeight: 500,
                  }}
                />
              )}
            </Box>
            <Button
              variant="contained"
              startIcon={currentStructure.isDefault ? <CheckCircleIcon /> : <StarBorderIcon />}
              onClick={() => handleSetDefault(selected)}
              sx={{
                borderRadius: 2,
                textTransform: "none",
                fontWeight: 600,
                background: currentStructure.isDefault 
                  ? "linear-gradient(45deg, #4CAF50 30%, #2E7D32 90%)"
                  : "linear-gradient(45deg, #7564e6 30%, #7564e6 90%)",
                "&:hover": {
                  background: currentStructure.isDefault
                    ? "linear-gradient(45deg, #2E7D32 30%, #1B5E20 90%)"
                    : "linear-gradient(45deg, #7564e6 30%, #5A3A64 90%)",
                },
                width: isSm ? '100%' : 'auto'
              }}
            >
              {currentStructure.isDefault ? "Default Structure" : "Set as Default"}
            </Button>
          </Box>

          {/* Structure Info */}
          <Grid container spacing={3} sx={{ mb: 4 }}>
            <Grid item xs={12} md={6}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2, flexWrap: 'wrap' }}>
                <Typography variant="subtitle1" fontWeight={600} color="text.primary">
                  Structure Name:
                </Typography>
                <Typography variant="body1" sx={{ mr: 1 }}>
                  {currentStructure.name}
                </Typography>
                <Tooltip title="Edit Name">
                  <IconButton size="small" onClick={handleEditName}>
                    <EditIcon fontSize="small" color="primary" />
                  </IconButton>
                </Tooltip>
              </Box>
              <Box>
                <Typography variant="subtitle1" fontWeight={600} color="text.primary" gutterBottom>
                  Description:
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {currentStructure.description}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box sx={{ 
                display: "flex", 
                gap: 2,
                flexDirection: isSm ? 'column' : 'row'
              }}>
                <Card variant="outlined" sx={{ 
                  flex: 1, 
                  borderRadius: 2,
                  minWidth: isSm ? '100%' : 'auto'
                }}>
                  <CardContent sx={{ textAlign: "center", py: 2 }}>
                    <Typography variant="h6" color="primary" fontWeight={700}>
                      {currentStructure.employeeCount}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Employees
                    </Typography>
                  </CardContent>
                </Card>
                <Card variant="outlined" sx={{ 
                  flex: 1, 
                  borderRadius: 2,
                  minWidth: isSm ? '100%' : 'auto'
                }}>
                  <CardContent sx={{ textAlign: "center", py: 2 }}>
                    <Typography variant="h6" color="primary" fontWeight={700}>
                      {currentStructure.earnings.length + currentStructure.deductions.length}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Components
                    </Typography>
                  </CardContent>
                </Card>
              </Box>
            </Grid>
          </Grid>

          {/* Components Section */}
          <Typography variant="h6" fontWeight={600} color="primary" gutterBottom sx={{ mb: 3 }}>
            Salary Components
          </Typography>

          <Grid 
            container 
            spacing={3}
            sx={{ flexDirection: isSm ? 'column' : 'row' }}
          >
            {/* Earnings Table */}
            <Grid item xs={12} lg={6} sx={{ width: '100%' }}>
              <TableContainer 
                component={Paper} 
                elevation={0}
                sx={{ 
                  borderRadius: 2,
                  border: "1px solid",
                  borderColor: "divider",
                  overflow: "auto",
                  maxHeight: isSm ? '300px' : 'auto'
                }}
              >
                <Table size={isSm ? "small" : "medium"}>
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "primary.main" }}>
                      <TableCell sx={{ color: "white", fontWeight: 600, py: 1.5, fontSize: isSm ? '0.75rem' : '0.875rem' }}>
                        Earnings
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: 600, py: 1.5, fontSize: isSm ? '0.75rem' : '0.875rem' }}>
                        Calculation
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: 600, py: 1.5, width: isSm ? 60 : 80, fontSize: isSm ? '0.75rem' : '0.875rem' }}>
                        Actions
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {currentStructure.earnings.map((earning) => (
                      <TableRow 
                        key={earning.id}
                        sx={{ 
                          '&:nth-of-type(odd)': { backgroundColor: 'action.hover' },
                          '&:hover': { backgroundColor: 'action.selected' }
                        }}
                      >
                        <TableCell sx={{ py: 1.5, fontSize: isSm ? '0.75rem' : '0.875rem' }}>
                          <Typography variant="body2" fontWeight={500}>
                            {earning.name}
                          </Typography>
                        </TableCell>
                        <TableCell sx={{ py: 1.5 }}>
                          <Chip
                            label={earning.calculation}
                            size="small"
                            variant="outlined"
                            sx={{ 
                              fontSize: isSm ? '0.65rem' : '0.75rem',
                              backgroundColor: earning.calculation === "Fixed" ? "#E8F5E9" : "#E3F2FD",
                              color: earning.calculation === "Fixed" ? "#2E7D32" : "#7564e6"
                            }}
                          />
                        </TableCell>
                        <TableCell sx={{ py: 1.5 }}>
                          {earning.editable && (
                            <Tooltip title="Delete">
                              <IconButton 
                                size="small"
                                onClick={() => handleDeleteComponent("earnings", earning.id)}
                              >
                                <DeleteIcon fontSize={isSm ? "small" : "medium"} color="error" />
                              </IconButton>
                            </Tooltip>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>

            {/* Deductions Table */}
            <Grid item xs={12} lg={6} sx={{ width: '100%' }}>
              <TableContainer 
                component={Paper} 
                elevation={0}
                sx={{ 
                  borderRadius: 2,
                  border: "1px solid",
                  borderColor: "divider",
                  overflow: "auto",
                  maxHeight: isSm ? '300px' : 'auto'
                }}
              >
                <Table size={isSm ? "small" : "medium"}>
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "error.main" }}>
                      <TableCell sx={{ color: "white", fontWeight: 600, py: 1.5, fontSize: isSm ? '0.75rem' : '0.875rem' }}>
                        Deductions
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: 600, py: 1.5, fontSize: isSm ? '0.75rem' : '0.875rem' }}>
                        Calculation
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: 600, py: 1.5, width: isSm ? 60 : 80, fontSize: isSm ? '0.75rem' : '0.875rem' }}>
                        Actions
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {currentStructure.deductions.map((deduction) => (
                      <TableRow 
                        key={deduction.id}
                        sx={{ 
                          '&:nth-of-type(odd)': { backgroundColor: 'action.hover' },
                          '&:hover': { backgroundColor: 'action.selected' }
                        }}
                      >
                        <TableCell sx={{ py: 1.5, fontSize: isSm ? '0.75rem' : '0.875rem' }}>
                          <Typography variant="body2" fontWeight={500}>
                            {deduction.name}
                          </Typography>
                        </TableCell>
                        <TableCell sx={{ py: 1.5 }}>
                          <Chip
                            label={deduction.calculation}
                            size="small"
                            variant="outlined"
                            sx={{ 
                              fontSize: isSm ? '0.65rem' : '0.75rem',
                              backgroundColor: "#FFEBEE",
                              color: "#C62828"
                            }}
                          />
                        </TableCell>
                        <TableCell sx={{ py: 1.5 }}>
                          {deduction.editable && (
                            <Tooltip title="Delete">
                              <IconButton 
                                size="small"
                                onClick={() => handleDeleteComponent("deductions", deduction.id)}
                              >
                                <DeleteIcon fontSize={isSm ? "small" : "medium"} color="error" />
                              </IconButton>
                            </Tooltip>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>

          {/* Add Component Button */}
          <Box sx={{ mt: 3, textAlign: "center" }}>
            <Button
              variant="outlined"
              startIcon={<AddIcon />}
              onClick={() => setShowComponentPopup(true)}
              sx={{
                borderRadius: 2,
                py: 1,
                px: 3,
                borderColor: "primary.main",
                color: "primary.main",
                fontWeight: 600,
                textTransform: "none",
                width: isSm ? '100%' : 'auto',
                "&:hover": {
                  borderColor: "primary.dark",
                  backgroundColor: "primary.light",
                }
              }}
            >
              Add New Component
            </Button>
          </Box>
        </CardContent>
      </Card>
    );
  };

  return (
    <Box sx={{ 
      p: { xs: 0.5, sm: 1, md: 2, lg: 3 }, 
      backgroundColor: "#f5f7fa", 
      minHeight: "100vh",
      width: '100%',
      overflowX: 'hidden'
    }}>
      {/* Responsive View Switching */}
      {isMobile ? renderMobileView() : renderDesktopView()}

      {/* Create Structure Popup */}
      <Dialog 
        open={showCreatePopup} 
        onClose={() => setShowCreatePopup(false)}
        maxWidth="xs"
        fullWidth
        fullScreen={isMobile}
      >
        <DialogTitle>
          <Typography variant="h6" fontWeight={600}>
            Create New Structure
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Select the type of salary structure you want to create
          </Typography>
          <RadioGroup
            value={selectedType}
            onChange={(e) => setSelectedType(e.target.value)}
            sx={{ mt: 2 }}
          >
            <FormControlLabel
              value="Regular"
              control={<Radio />}
              label={
                <Box>
                  <Typography variant="body1" fontWeight={500}>Regular</Typography>
                  <Typography variant="caption" color="text.secondary">
                    For full-time employees with all benefits
                  </Typography>
                </Box>
              }
            />
            <FormControlLabel
              value="Contractor"
              control={<Radio />}
              label={
                <Box>
                  <Typography variant="body1" fontWeight={500}>Contractor</Typography>
                  <Typography variant="caption" color="text.secondary">
                    For contract-based employment
                  </Typography>
                </Box>
              }
            />
          </RadioGroup>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3 }}>
          <Button 
            onClick={() => setShowCreatePopup(false)}
            sx={{ 
              color: "text.secondary",
              textTransform: "none",
              fontWeight: 500
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              console.log("Creating structure type:", selectedType);
              setShowCreatePopup(false);
              showSnackbar("New structure created!", "success");
            }}
            sx={{
              textTransform: "none",
              fontWeight: 600,
              borderRadius: 2,
              px: 3,
              background: "linear-gradient(135deg, #7564e6, #7564e6)",
              color :"white"
            }}
          >
            Continue
          </Button>
        </DialogActions>
      </Dialog>

      {/* Add Component Popup */}
      <Dialog 
        open={showComponentPopup} 
        onClose={() => setShowComponentPopup(false)}
        maxWidth="sm"
        fullWidth
        fullScreen={isMobile}
      >
        <DialogTitle>
          <Typography variant="h6" fontWeight={600}>
            Add New Component
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Component Name"
                value={newComponent.name}
                onChange={(e) => setNewComponent({...newComponent, name: e.target.value})}
                size="small"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12}>
              <RadioGroup
                row
                value={newComponent.type}
                onChange={(e) => setNewComponent({...newComponent, type: e.target.value})}
                sx={{ justifyContent: isMobile ? 'space-between' : 'flex-start' }}
              >
                <FormControlLabel 
                  value="earning" 
                  control={<Radio />} 
                  label="Earning" 
                  sx={{ mr: isMobile ? 0 : 2 }}
                />
                <FormControlLabel 
                  value="deduction" 
                  control={<Radio />} 
                  label="Deduction" 
                />
              </RadioGroup>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Calculation Formula"
                placeholder="e.g., BASIC * 0.4 or Fixed Amount"
                value={newComponent.calculation}
                onChange={(e) => setNewComponent({...newComponent, calculation: e.target.value})}
                size="small"
                variant="outlined"
                helperText="Enter calculation formula or 'Fixed' for fixed amount"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3 }}>
          <Button 
            onClick={() => setShowComponentPopup(false)}
            sx={{ 
              color: "text.secondary",
              textTransform: "none",
              fontWeight: 500
            }}
          >
            Cancel
          </Button>
          <Button style={{color:'white'}}
            variant="contained"
            onClick={handleAddComponent}
            disabled={!newComponent.name.trim() || !newComponent.calculation.trim()}
            sx={{
              textTransform: "none",
              fontWeight: 600,
              borderRadius: 2,
              px: 3,
            
               background: "linear-gradient(135deg, #7564e6, #7564e6)",
               
            }}
          >
            Add Component
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert 
          onClose={handleCloseSnackbar} 
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default Saturated;